"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stdGrid_1 = require("views/stdGrid");
const globals_1 = require("models/globals");
const tools_1 = require("../outils/tools");
class UserConnexions extends stdGrid_1.default {
    constructor(app, name) {
        super(app, name, {
            moduleName: "connexions",
            datatableName: "connexionsdatatable",
            columns: [
                { id: "unid", header: (0, globals_1._)("N°"), width: 80, css: { "text-align": "right" }, sort: "int", hidden: true },
                { id: "userId", header: (0, globals_1._)("Utilisateur"), width: 100, css: { "text-align": "right" }, sort: "text" },
                { id: "online", template: tools_1.custom_checkbox // , editor : "checkbox"
                    ,
                    header: (0, globals_1._)("En ligne"), width: 100, sort: "int", disabled: true,
                    uncheckValue: "0", value: "0", checkValue: "1", tooltip: (0, globals_1._)("En ligne") },
                { id: "name", header: (0, globals_1._)("Nom"), width: 300, sort: "text" },
                { id: "loginTime", header: (0, globals_1._)("Connexion"), width: 180, sort: "text" },
                { id: "lastActionTime", header: (0, globals_1._)("Dernière action"), width: 180, sort: "text" },
                { id: "logoutTime", header: (0, globals_1._)("Déconnexion"), width: 200, sort: "text" }
            ],
            title: (0, globals_1._)("Connexions utilisateurs"),
            boutons: {
                id: "unlockButton", "view": "button", width: 250,
                type: "icon", icon: "mdi mdi-account-minus-outline", "value": (0, globals_1._)("Supprimer les verrous")
            },
            resizeColumn: true,
            multiselect: false,
            urlData: globals_1.phpPath + "utilisateurs.php?option=listConnected",
        });
    }
    supprimerVerrous() {
        let me = this;
        let view = this.currentGrid;
        if (!view.getSelectedId(true, true)) {
            webix.message((0, globals_1._)("Aucune ligne n'est sélectionnée"));
            return;
        }
        let data = view.getSelectedItem();
        if (data) {
            let userId = data.userId;
            // @ts-ignore
            let promise = webix.ajax().get(globals_1.phpPath + "utilisateurs.php?option=unlockRecords&userId=" + userId);
            promise.then(function (result) {
                if (result.json().success == false) {
                    webix.alert(result.json().message);
                    return;
                }
                else {
                    webix.message((0, globals_1._)("Les verrous de cet utilisateur sont supprimés"));
                }
            });
        }
        else {
            webix.alert((0, globals_1._)("Aucune ligne n'est sélectionnée"));
        }
    }
    init(baseview) {
        // l'appel de super.init permet d'éviter la nouvelle déclaration de this.currentGrid par exemple
        // toutefois, je ne suis pas sûr que ce soit la bonne option
        super.init(baseview);
        let me = this;
        let menu = this.$$("stdGridMenu");
        menu.attachEvent("onMenuItemClick", function (id, e, node) {
            switch (id) {
                case "unlockButton":
                    me.supprimerVerrous();
                    break;
            }
        });
    }
}
exports.default = UserConnexions;
